import React, { useEffect } from 'react';

import { useApolloClient, useQuery } from '@apollo/react-hooks';
import gql from 'graphql-tag';

import StandardSceneWrapper from 'Components-redesign/StandardSceneWrapper';

import { GetBalanceAccount, GetCompanyAndAccounts } from './__queries__';

const ACCOUNT_QUERY = gql`
  query GetCompanyAndAccounts($id: ID!, $path: String!) {
    company: Company(id: $id) {
      id
      adyenAccountHolders {
        id
        onboardingUrl(returnUrl: $path)
      }
    }
  }
`;

const BALANCE_ACCOUNT_QUERY = gql`
  query GetBalanceAccount($id: String!, $url: String!) {
    adyenBalanceLegalEntity(id: $id) {
      id
      KYCLink(redirectUrl: $url)
    }
  }
`;

interface Props {
  companyId: string;
  accountId: string;
}

const AnonymousAdyenKYC: React.FC<Props> = ({ companyId, accountId }) => {
  const client = useApolloClient();
  const query = useQuery<GetCompanyAndAccounts>(ACCOUNT_QUERY, {
    variables: {
      id: companyId,
      path: 'https://vm.baemingo.se',
    },
  });
  const accounts = query.data?.company?.adyenAccountHolders ?? [];

  const balanceQuery = useQuery<GetBalanceAccount>(BALANCE_ACCOUNT_QUERY, {
    variables: {
      id: accountId,
      url: 'https://vm.baemingo.se',
    },
  });
  const balanceAccount = balanceQuery.data?.adyenBalanceLegalEntity;

  const account = accounts.find((a) => a.id === accountId);

  useEffect(() => {
    if (!balanceAccount) {
      return;
    }

    setTimeout(() => {
      window.location.href = balanceAccount.KYCLink;
    }, 2000);
  }, [balanceAccount]);

  useEffect(() => {
    if (!account) {
      return;
    }

    setTimeout(() => {
      window.location.href = account.onboardingUrl;
    }, 2000);
  }, [account]);

  return (
    <StandardSceneWrapper
      title="Identity Verification & Bank Setup"
      description="We need to collect some information from you. You will be redirected in two seconds...">
      <h2>Loading</h2>
    </StandardSceneWrapper>
  );
};

export default AnonymousAdyenKYC;
